import React from 'react';
import { Stack, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as Sentry from "@sentry/browser";
import { glassCard } from '../../designsystem/tokens';

class ValidationErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, { extra: errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <Stack spacing={2} alignItems="center"
                    role="alert" aria-live="assertive"
                    sx={{ width: '100%', padding: '2rem 1rem', ...glassCard }}>
                    <ErrorOutlineIcon sx={{ fontSize: 56, color: '#76A9AC' }} />
                    <Typography variant="body1" align="center" sx={{ color: '#ffffffb0', lineHeight: 1.6 }}>
                        {this.props.errorMessage}
                    </Typography>
                    <Stack direction="row" spacing={1.5} sx={{ width: '100%' }}>
                        <Button variant="outlined" startIcon={<RefreshIcon />}
                            onClick={() => this.setState({ hasError: false })}
                            sx={{ flex: 1, minHeight: 48 }}>
                            {this.props.retryLabel || 'Reintentar'}
                        </Button>
                        <Button variant="outlined" startIcon={<SkipNextIcon />}
                            onClick={this.props.onSkip}
                            sx={{ flex: 1, minHeight: 48 }}>
                            {this.props.skipLabel}
                        </Button>
                    </Stack>
                </Stack>
            );
        }
        return this.props.children;
    }
}

export default ValidationErrorBoundary;
